export const SUPPORT_DROPDOWN_CONSTANTS = {
  HELP_CENTER: "HELP_CENTER",
  WHATS_NEW: "WHATS_NEW",
  TODDLE_ACADEMY: "TODDLE_ACADEMY",
  QUICK_SEARCH: "QUICK_SEARCH",
  CONTACT_SUPPORT: "CONTACT_SUPPORT",
  ADMIN: "admin",
  TEACHER: "teacher",
  COMMUNITY: "community",
  SCHOOL_SUPPORT: "SCHOOL_SUPPORT",
  MAPLE_BEAR_CENTRAL_SUPPORT: "MAPLE_BEAR_CENTRAL_SUPPORT",
  DIVIDER_1: "divider_1",
  DIVIDER_2: "divider_2",
  ROADMAP_FEATURES_REQUEST: "ROADMAP_FEATURES_REQUEST",
};
